<template>
    <v-layout>
        <v-flex xs12>
            <v-layout justify-space-between row wrap>
                <v-flex xs12 pa-0>
                    <v-container fluid grid-list-xl>
                        <v-layout row wrap>
                            <v-autocomplete
                                label="Tipo de Setor"
                                v-model="sectorType"
                                :items="sectorTypes"
                                return-object
                                :item-text="sectorType"
                                dense
                                box
                                @change="changeSector"
                                :disabled="situationEditDisabled || finalizedContract || disableTagsInThePage"
                            ></v-autocomplete>
                            <v-btn
                                style="float: right"
                                dark
                                color="primary"
                                fab
                                small
                                @click="situationEditDisabled = !situationEditDisabled"
                                :disabled="finalizedContract || disableTagsInThePage"
                            >
                                <v-icon class="white--text" v-if="situationEditDisabled">edit</v-icon>
                                <v-icon class="white--text" v-else>check</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-container>
                </v-flex>
                <!-- ENDEREÇO -->
                <v-flex xs12>
                    <v-container fluid grid-list-xl>
                        
                        <v-layout row wrap>
                            <v-flex xs12 mb-3>
                                <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 v-if="isPageRequest">
                            <v-container fluid grid-list-xl>
                                <v-layout row justify-end>
                                    <v-flex xs12>
                                        <h2 class="grey--text">Endereço de entrega</h2>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    type="text"
                                    label="Setor"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    v-model="department.name"
                                    box
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    type="text"
                                    label="CEP"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    v-model="department.address.cep"
                                    box
                                    @input="findAddressByCep"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    type="text"
                                    label="Logradouro"
                                    :readonly="finalizedContract"
                                    v-model="department.address.addressType"
                                    box
                                    :disabled="isSearchingAddress || disableTagsInThePage"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm3>
                                <v-text-field
                                    type="text"
                                    :readonly="finalizedContract"
                                    label="Número"
                                    v-model="department.address.number"
                                    box
                                    :disabled="isSearchingAddress || disableTagsInThePage "
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    type="text"
                                    :readonly="finalizedContract"
                                    label="Complemento"
                                    v-model="department.address.complement"
                                    box
                                    :disabled="isSearchingAddress || disableTagsInThePage "
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-text-field
                                    type="text"
                                    :readonly="finalizedContract"
                                    label="Bairro"
                                    v-model="department.address.district"
                                    box
                                    :disabled="isSearchingAddress || disableTagsInThePage "
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-autocomplete
                                    label="Município"
                                    :readonly="finalizedContract"
                                    v-model="department.address.cityOfService"
                                    :items="cities"
                                    :item-text="cityText"
                                    return-object
                                    dense
                                    solo
                                    box
                                    :disabled="isSearchingAddress || disableTagsInThePage "
                                >
                                    <template v-slot:append-outer>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                    v-on="on"
                                                    :disabled="finalizedContract"
                                                    @click="buttonAddNewCity"
                                                >add</v-icon>
                                            </template>
                                            Cadastrar nova Cidade!
                                        </v-tooltip>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                            <v-dialog v-model="showDialogAddNewCity" max-width="500">
                                <form-city
                                    @cancelNewCity="closeDialogNewCity"
                                    @savedCity="savedCity"
                                ></form-city>
                            </v-dialog>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <!--ENDEREÇO  -->
            <v-divider class="pb-3" />

            <!-- FUNÇÃO -->
            <v-layout justify-space-between row wrap v-if="!isPageRequest">
                <v-flex xs12>
                    <v-container fluid grid-list-xl>
                        <v-layout row wrap>
                            <v-flex xs12 sm2>
                                <v-autocomplete
                                    label="Unidade de medida"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    :items="unitsOfMeasurement"
                                    v-model="department.unitOfMeasurement"
                                    box
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-autocomplete
                                    label="Descrição do Serviço"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    :items="offices"
                                    item-text="description"
                                    v-model="department.office"
                                    item-value="_id"
                                    dense
                                    return-object
                                    box
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    type="number"
                                    min="1"
                                    :readonly="finalizedContract"
                                    :disabled="disableTagsInThePage"
                                    label="Quantidade de empregados a contratar"
                                    v-model="department.numberOfEmployees"
                                    box
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    :readonly="finalizedContract"
                                    label="Ano do acordo, convenção ou dissído coletivo"
                                    :items="agreementsYear"
                                    item-text="year"
                                    v-model="department.collectiveConvention"
                                    :disabled="disableTagsInThePage"
                                    item-value="_id"
                                    dense
                                    box
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    label="Categoria profissional"
                                    :readonly="finalizedContract"
                                    :items="agreementYearSelectedItems"
                                    item-text="occupation"
                                    v-model="department.professionalCategory"
                                    dense
                                    return-object
                                    persistent-hint
                                    box
                                    :disabled="!department.collectiveConvention || disableTagsInThePage"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    label="Carga Horária"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    v-model="department.additionalInfo"
                                    box
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    label="Data base da categoria"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    v-model="department.dataBaseOfTheCategory"
                                    box
                                    type="date"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="department.mainNotes"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    label="Notas Principais"
                                    rows="5"
                                    box
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="department.complementariesNotes"
                                    :disabled="disableTagsInThePage"
                                    :readonly="finalizedContract"
                                    label="Notas Complementares"
                                    rows="5"
                                    box
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
import FormCity from '../../budget/FormCity'
import CollectiveConventionService from './../../../service/CollectiveConventionService'
import CityService from './../../../service/CityService'
import OfficceService from './../../../service/OfficceService.js'
import UtilService from './../../../service/UtilService.js'
export default {
    props: {
        finalizedContract: Boolean,
        contractHaveBudgetImported: Boolean,
        contractDontHaveBudgetButIsFinished: Boolean,
        isPageRequest: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        FormCity,
    },
    computed: {
        disableTagsInThePage() {
            if (
                this.contractHaveBudgetImported ||
                this.contractDontHaveBudgetButIsFinished
            ) {
                return true
            } else return false
        },
    },
    data() {
        return {
            agreementsYear: [],
            agreementYearSelected: '',
            agreementYearSelectedItems: [],
            cities: [],
            department: {
                address: {
                    cityOfService: {},
                },
            },

            isSearchingAddress: false,
            offices: [],
            sectorType: '',
            sectorTypes: ['Setor Sede', 'Outro Setor'],
            situationEditDisabled: true,
            unitsOfMeasurement: ['Posto de Serviço', 'M²'],
            showDialogAddNewCity: false,
        }
    },
    methods: {
        init() {
            this.changeOfficces()
            this.fillCitiesTable()
            this.changeAgreementsYear()
        },

        buttonAddNewCity() {
            this.showDialogAddNewCity = true
        },
        closeDialogNewCity() {
            this.showDialogAddNewCity = false
            /* 430 */
        },
        savedCity() {
            this.fillCitiesTable()
            this.showDialogAddNewCity = false
        },
        async editDepartment(index) {
            this.department = index
            if (this.department.name == 'SEDE') {
                this.sectorType = 'Setor Sede'
            } else {
                this.sectorType = 'Outro Setor'
            }
        },

        saveDepartment(/* department */) {
            let dep = this.department
            dep.lastName = 'Função Indefinida'
            if (!dep.name) {
                dep.name = 'Setor Indefinido'
            }
            if (this.department.professionalCategory) {
                dep.lastName = this.department.professionalCategory.occupation
            }
            this.resetDepartment()
            return dep
        },
        async changeAgreementsYear() {
            try {
                this.agreementsYear = await CollectiveConventionService.getAll()
                this.agreementsYear.sort()
            } catch (error) {}
        },
        sectorText: item => `${item}`,
        async changeOfficces() {
            try {
                this.offices = await OfficceService.getAll()
                this.offices.sort()
            } catch (error) {}
        }, //changeOfficces()
        async changeSector() {
            if (this.sectorType == 'Setor Sede') {
                this.department.name = 'SEDE'
                this.$emit('chengedSector')
            } else {
                this.department.name = ''
                this.department.sectorType = 'OTHER'
                this.department.address.sectorType = 'OTHER'
                this.department.address.cityOfService = {}
                this.department.address.complement = ''
                this.department.address.district = ''
                this.department.address.number = ''
                this.department.address.addressType = ''
                this.department.address.cep = ''
                this.department.address.sector = ''
            }
        },
        async setAddress(address) {
            this.department.address = address
            this.department.address.sector = 'SEDE'
            this.department.address.cityOfService = {}
            this.department.address.cityOfService = await this.findCityByNameAndState(
                address
            )
        },
        findCityByNameAndState(address) {
            if (!this.cities) return

            for (let i = 0; i < this.cities.length; i++) {
                if (
                    address.city.toUpperCase() ==
                        this.cities[i].name.toUpperCase() &&
                    address.state.toUpperCase() ==
                        this.cities[i].state.toUpperCase()
                ) {
                    return this.cities[i]
                }
            }
        },
        cityText: item => `${item.name} - ${item.state} (${item.uf})`,

        async fillCitiesTable() {
            try {
                this.cities = await CityService.getAll()
            } catch (error) {
                console.log(error)
            }
        },
        async findAddressByCep() {
            try {
                if (
                    this.department.address.cep &&
                    this.department.address.cep.length == 8
                ) {
                    this.isSearchingAddress = true
                    this.department.address = await UtilService.findAddressByCep(
                        this.department.address.cep
                    )
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.isSearchingAddress = false
            }
        },
        resetDepartment() {
            this.sectorType = ''
            this.department = {
                address: {
                    cityOfService: {},
                },
            }
        },
    },
    beforeMount() {
        this.init()
    },
    watch: {
        'department.collectiveConvention': {
            handler: function(newValue, oldValue) {
                if (oldValue && newValue != oldValue)
                    this.department.professionalCategory = {}

                let selected = this.agreementsYear.find(
                    x => x._id === this.department.collectiveConvention
                )
                if (selected) {
                    this.department.minimalSalary = selected.minimalSalary
                    this.agreementYearSelectedItems = selected.items
                    this.department.dataBaseOfTheCategory =
                        selected.dataBaseOfTheCategory
                }
            },
            deep: true,
        },
    },
}
</script>
/* */



// WEBPACK FOOTER //
// src/components/contract/department/Department.vue